export default {
    SET_USER_NOTIFICATIONS(state, userNotifications) {
        state.userNotifications = userNotifications
    },
    READ_USER_NOTIFICATION(state, userNotificationId) {
        const ItemIndex = state.userNotifications.findIndex((w) => w.id === userNotificationId)
        state.userNotifications.splice(ItemIndex, 1)
    }
}
